import ReactMapboxGl, {Image} from 'react-mapbox-gl';
import React, {ReactNode} from 'react';
import {FitBoundsOptions, Style} from 'mapbox-gl';
import {Props} from 'react-mapbox-gl/lib/map';
import {Events} from 'react-mapbox-gl/lib/map-events';
import {linetBounds} from '@zvne/fe-framework/dist/utilities/geometry';
import {MapLoadingContextProvider} from '@zvne/fe-framework/dist/presentation/map/guards/map-loading-context';
import {MapResizeDetector} from '@zvne/fe-framework/dist/presentation/map/misc/map-resize-detector.';
import {MapMiddleMousePanner} from '@zvne/fe-framework/dist/presentation/map/misc/map-middle-mouse-panner';
import {MapCtrlZoomModifier} from '@zvne/fe-framework/dist/presentation/map/misc/map-ctrl-zoom-modifier';
import {NavigationControl} from '@zvne/fe-framework/dist/presentation/map/controls/navigation-control';
import {FullScreenControl} from '@zvne/fe-framework/dist/presentation/map/controls/full-screen-control';
import {DistanceControl} from '@zvne/fe-framework/dist/presentation/map/controls/distance-control';
import {ExportControl} from '@zvne/fe-framework/dist/presentation/map/controls/export-control';
import arrowLight from '@zvne/fe-framework/dist/presentation/map/img/arrow-light.png';
import arrowDark from '@zvne/fe-framework/dist/presentation/map/img/arrow-dark.png';
import {BackgroundLayer} from './layer/background-layer';
import {InfrastructureLayers} from './layer/infrastructure-layers';
import './map.css';

const ReactMapboxMap = ReactMapboxGl({
    accessToken: 'pk.eyJ1IjoidGk0ODQ4NyIsImEiOiJja3g2MHQ3Y2kwNWFkMnZvMHIwMngwYXFhIn0.kw7ycOuAvMMg_PEwv4Uu3A'
});

const emptyStyle: Style = {
    version: 8,
    name: 'Empty',
    sprite: 'mapbox://sprites/mapbox/streets-v8',
    glyphs: 'mapbox://fonts/mapbox/{fontstack}/{range}.pbf',
    sources: {},
    layers: []
};

export type MapboxMapProps = Partial<Omit<Props, 'children'> & Events & { children: ReactNode }>;

const fitBoundsOptions: FitBoundsOptions = {
    duration: 0
};

export function MapboxMap(props: MapboxMapProps) {
    return (
        <ReactMapboxMap
            style={emptyStyle}
            fitBounds={linetBounds}
            fitBoundsOptions={fitBoundsOptions}
            {...props}
        >
            <MapLoadingContextProvider>
                <MapResizeDetector/>
                <MapMiddleMousePanner/>
                <MapCtrlZoomModifier/>
                <Image id={'arrow-light'} url={arrowLight}/>
                <Image id={'arrow-dark'} url={arrowDark}/>
                <NavigationControl position={'top-left'} order={0.1}/>
                <FullScreenControl position={'top-left'} order={0.2}/>
                <DistanceControl position={'top-left'} order={0.3}/>
                <ExportControl position={'top-left'} showBottomRightControls order={0.4}/>
                <BackgroundLayer/>
                <InfrastructureLayers/>
                {props.children}
            </MapLoadingContextProvider>
        </ReactMapboxMap>
    );
}
